import axios from 'axios';
import {useMutation} from 'react-query';

interface ResetPassword {
    code: string,
    email: string,
    password: string
}

export const useResetPassword = () => {
    const resetPassword = async (values: ResetPassword) => {
        const baseURL = process.env.REACT_APP_BASE_URL;
        return await axios.post(`${baseURL}/wp-json/bdpwr/v1/set-password`, values);
    };
    return useMutation('reset-password', resetPassword);
};

export default useResetPassword;
